import React from 'react';
import { createContext, useState } from 'react';
import { useLocation } from 'react-router-dom';

export interface SidebarContextType {
    isExpanded: boolean;
    setIsExpanded: React.Dispatch<React.SetStateAction<boolean>>;
    color: string;
    setColor: React.Dispatch<React.SetStateAction<string>>;
    fill: string;
    setFill: React.Dispatch<React.SetStateAction<string>>;
    stroke: string;
    setStroke: React.Dispatch<React.SetStateAction<string>>;
    logo: string;
    setLogo: React.Dispatch<React.SetStateAction<string>>;
    pathname: any;
    position: string;
    setPosition: React.Dispatch<React.SetStateAction<string>>;
}

type ChildrenProps = {
  children: React.ReactNode;
};

export const SidebarContext = createContext<SidebarContextType>({} as SidebarContextType);

export const SidebarProvider: React.FC<ChildrenProps> = ({ children }) => {
  const [isExpanded, setIsExpanded] = useState<any>(false)

  const [color, setColor] = useState("bg-[#212632]");
  const [fill, setFill] = useState("#212632");
  const [stroke, setStroke] = useState("#2d3440");
  const [logo, setLogo] = useState("img/navigation/home.png");
  const { pathname } = useLocation();
  const [position, setPosition] = useState<string>("left"); // Add position state


  React.useEffect(() => {
    switch (pathname) {
      case "/redesign":
        setColor("bg-[#212632]")
        setFill("#212632")
        setStroke("#2d3440")
        setLogo("img/navigation/home.png")
        break;
      case "/coinflip":
        setColor("bg-[#ab8060]")
        setFill("#ab8060")
        setStroke("#454e5b")
        setLogo("img/navigation/degencoinflip.png")
        break;
      case "/dozer":
        setColor("bg-[#802e3c]")
        setFill("#802e3c")
        setStroke("#454e5b")
        setLogo("img/navigation/degencoindozer.png")
        break;
      case "/spin":
        setColor("bg-[#58456f]")
        setFill("#58456f")
        setStroke("#454e5b")
        setLogo("img/navigation/degenspin.png")
        break;
      case "/crash":
        setColor("bg-[#2f5b43]")
        setFill("#2f5b43")
        setStroke("#454e5b")
        setLogo("img/navigation/degencrash.png")
        break;
      case "/towers":
        setColor("bg-[#d67e25]")
        setFill("#d67e25")
        setStroke("#454e5b")
        setLogo("img/navigation/degentowers.png")
        break;
    }
  }, [pathname])

  return (
    <SidebarContext.Provider
      value={{
        isExpanded,
        setIsExpanded,
        color,
        setColor,
        fill,
        setFill,
        stroke,
        setStroke,
        logo,
        setLogo,
        pathname,
        position,
        setPosition
      }}
    >
      {children}
    </SidebarContext.Provider>
  );
};
